var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "register-page-full" },
    [
      _vm._m(0),
      _c("div", { staticClass: "right-panel" }, [
        _c(
          "div",
          { staticClass: "card" },
          [
            _c("h3", { staticClass: "card-title" }, [
              _vm._v("Create your PayCools account"),
            ]),
            _c(
              "el-form",
              {
                ref: "registerForm",
                staticClass: "register-form",
                attrs: {
                  model: _vm.registerForm,
                  rules: _vm.registerRules,
                  "label-position": "top",
                  "auto-complete": "on",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Email address", prop: "email" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "Please enter your email address" },
                      model: {
                        value: _vm.registerForm.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.registerForm, "email", $$v)
                        },
                        expression: "registerForm.email",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "", prop: "verificationCode" } },
                  [
                    _c(
                      "div",
                      { staticClass: "verification-row" },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "verification-input",
                            attrs: {
                              placeholder: "Please enter the verification code",
                            },
                            model: {
                              value: _vm.registerForm.verificationCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.registerForm,
                                  "verificationCode",
                                  $$v
                                )
                              },
                              expression: "registerForm.verificationCode",
                            },
                          },
                          [
                            _c(
                              "template",
                              { slot: "append" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "send-btn link-style",
                                    attrs: {
                                      size: "small",
                                      type: "text",
                                      disabled:
                                        !_vm.isEmailValid ||
                                        _vm.sending ||
                                        _vm.sendCountdown > 0,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onSendClick($event)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.sendCountdown > 0
                                            ? "Resend (" +
                                                _vm.sendCountdown +
                                                "s)"
                                            : _vm.sending
                                            ? "Sending..."
                                            : "Send Verification Code"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Password", prop: "password" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: _vm.passwordType,
                        placeholder: "Please enter your password",
                        "show-password": "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.registerForm.password,
                        callback: function ($$v) {
                          _vm.$set(_vm.registerForm, "password", $$v)
                        },
                        expression: "registerForm.password",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "Confirm Password",
                      prop: "confirmPassword",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        type: _vm.passwordType,
                        placeholder: "Please enter your password again",
                        "show-password": "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.registerForm.confirmPassword,
                        callback: function ($$v) {
                          _vm.$set(_vm.registerForm, "confirmPassword", $$v)
                        },
                        expression: "registerForm.confirmPassword",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticClass: "agree-checkbox",
                        model: {
                          value: _vm.agreePolicy,
                          callback: function ($$v) {
                            _vm.agreePolicy = $$v
                          },
                          expression: "agreePolicy",
                        },
                      },
                      [
                        _vm._v(" I have read and agree to "),
                        _c(
                          "el-link",
                          {
                            staticClass: "policy-link",
                            attrs: { type: "primary", underline: "" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.openServices($event)
                              },
                            },
                          },
                          [_vm._v(" Services Agreements ")]
                        ),
                        _c("br"),
                        _vm._v(" and "),
                        _c(
                          "el-link",
                          {
                            staticClass: "policy-link",
                            attrs: { type: "primary", underline: "" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.openPrivacy($event)
                              },
                            },
                          },
                          [_vm._v(" Privacy Policy ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticClass: "create-row" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "create-btn full",
                        attrs: {
                          type: "primary",
                          disabled: !_vm.agreePolicy || _vm.creating,
                          loading: _vm.creating,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleCreate($event)
                          },
                        },
                      },
                      [_vm._v("Register")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "signin-line" },
                  [
                    _vm._v(" Already have an account? "),
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.goLogin($event)
                          },
                        },
                      },
                      [_vm._v("Sign in.")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("p", { staticClass: "footer-copy" }, [
              _vm._v("© 2026 PayCools (Payment Innovations Inc.)"),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSuccessDialog,
            width: "420px",
            "before-close": _vm.onSuccessDialogClose,
            "close-on-click-modal": false,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSuccessDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", padding: "24px 12px" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "18px",
                    color: "#1D3A71",
                    "font-weight": "600",
                    "margin-bottom": "12px",
                  },
                },
                [_vm._v("Registration Successful")]
              ),
              _c(
                "div",
                { staticStyle: { color: "#6B7280", "margin-bottom": "18px" } },
                [
                  _vm._v(
                    "You will be redirected to Login in " +
                      _vm._s(_vm.successCountdown) +
                      "s"
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goToLoginFromDialog },
                },
                [_vm._v("Go to Login (" + _vm._s(_vm.successCountdown) + "s)")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("PrivacyPolicy", {
        attrs: { visible: _vm.showPrivacyDialog },
        on: {
          "update:visible": function ($event) {
            _vm.showPrivacyDialog = $event
          },
        },
      }),
      _c("ServicesAgreements", {
        attrs: { visible: _vm.showServicesDialog },
        on: {
          "update:visible": function ($event) {
            _vm.showServicesDialog = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left-panel" }, [
      _c("div", { staticClass: "brand-area" }, [
        _c("img", {
          staticClass: "brand-logo",
          attrs: {
            src: require("@/assets/login/pc_img_logo_content_paycools.png"),
            alt: "PayCools",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }